import React, {useState, useCallback} from 'react';
import {FormControlWrapper, FormHelperTextWrapper, SelectWrapper} from './Select.styles';
import {AccentColorOptions} from 'epic-ue-theme';
import {SelectProps as MuiSelectProps} from '@material-ui/core/Select';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import {UeTheme} from 'epic-ue-theme/src/ueTheme.types';
export interface SelectProps extends MuiSelectProps {
    accentColor?: AccentColorOptions;
    helperText?: string;
    error?: boolean;
    children: React.ReactNode;
}

const useStyles = makeStyles((theme: UeTheme) =>
    createStyles({
        selectWrap: {
            background: 'unset',
            font: 'inherit',
            maxWidth: '100%'
        },
        select: {
            '&&&': {
                padding: '0 20px 0 0',
                height: 'unset',
                zIndex: 1,
                '&:focus-visible': {
                    outline: `1px solid ${theme.ue.colors.outline}`,
                    outlineOffset: '2px'
                }
            }
        },
        paper: {
            backgroundColor: theme.palette.common.white,
            borderRadius: 'unset',
            border: 'unset'
        },
        list: {
            padding: '0',
            minWidth: '280px'
        }
    })
);

export const Caret = (): JSX.Element => {
    return <span className="select-arrow" />;
};

export const Select = ({
    children,
    accentColor = 'sky',
    helperText,
    error,
    className = 'underlined-select',
    ...rest
}: SelectProps): JSX.Element => {
    const classes = useStyles();
    const color = error ? 'fire' : accentColor;
    const [isOpen, setIsOpen] = useState(false);
    const didOpen = useCallback(() => {
        setIsOpen(true);
    }, [setIsOpen, isOpen]);

    const didClose = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen, isOpen]);

    return (
        <FormControlWrapper>
            <SelectWrapper
                {...rest}
                disableUnderline={true}
                accentColor={color}
                variant="filled"
                displayEmpty
                className={`${className} ${isOpen ? 'opened' : ''}`}
                classes={{
                    root: classes.selectWrap,
                    select: classes.select
                }}
                IconComponent={Caret}
                onOpen={didOpen}
                onClose={didClose}
                MenuProps={{
                    classes: {
                        paper: classes.paper,
                        list: classes.list
                    },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    },
                    getContentAnchorEl: null
                }}>
                {children}
            </SelectWrapper>
            {helperText && <FormHelperTextWrapper>{helperText}</FormHelperTextWrapper>}
        </FormControlWrapper>
    );
};
